<div *ngIf="isLoading" style="width:100%;height:100%;background-color: #fff;position: fixed;top:0;left:0;z-index:9999;">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="!isLoading">
  <div class="container-fluid login main-content">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 col-sm-12">
        <div class="card bg-white shadow overflow-hidden">
          <div class="card-body p-0">


            <div class="wrap d-md-flex w-100">
              <div class="text-wrap p-4 p-lg-5 d-flex align-items-top order-md-last w-100" style="background: #f1f1f1;">
                <div class="text w-100">
                  <h2>Welcome to <br>Yo Scenario Library</h2>
                  <p class="mt-4">If you have an access code, please sign up or login to access your content. Once logged in, please
                    use the "Redeem Code" button to add the content to your library.</p>

                  <div class="text-center">
                    <p class="mt-5">Don't have an account?</p>
                    <a class="btn btn-cancel rounded-pill me-2 rounded" [routerLink]="['/register']"> Sign Up </a>

                  </div>
                </div>
              </div>
              <div class="login-wrap p-4 p-lg-5 w-100">

                <h2 class="card-title mb-3 m text-start">Login</h2>
                <div *ngIf="testSite">
                  <p class="lead text-center">
                    This is a test environment for training purposes.
                  </p>
                </div>
                <form #authForm="ngForm" (ngSubmit)="onSubmit(authForm)" *ngIf="!isLoading">
                  <div class="form-group mb-4">
                    <label for="email" class="form-label">Email Address</label>
                    <input type="email" id="email" class="form-control" [ngClass]="{ 'is-invalid': error }"
                      [(ngModel)]="emailObj" name="email" placeholder="Email" required email autocomplete="off" />
                  </div>
                  <div class="form-group mb-4">
                    <label for="password" class="form-label">Password</label>
                    <input type="password" id="password" class="form-control" [ngClass]="{ 'is-invalid': error }"
                      ngModel name="password" required minlength="6" placeholder="Password" autocomplete="off" />
                  </div>

                  <div class="form-text text-danger" *ngIf="error">
                    <p>{{ error }}</p>
                  </div>

                  <div class="form-group mb-4">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="rememberMe" name="rememberMe" ngModel
                        value="1" />
                      <label class="form-check-label" for="rememberMe">Remember me</label>
                    </div>
                  </div>

                  <button type="submit" [disabled]="!authForm.valid" class="btn btn-dark w-100 rounded-pill shadow-sm">
                    Sign in
                  </button>
                </form>

                <div class="p-4 text-center">
                  <asl-google-signin-button type="standard" size="large" shape="pill"></asl-google-signin-button>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col text-center">
            <a href="https://app.yoscenario.com/forgotten-password" target="_blank">Forgotten Password? </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="mailto:support@yoscenario.com">Help </a>
          </div>
        </div>
        <!--span
              >Don’t have an account?
              <a [routerLink]="['/register']">Sign up now</a></span
            -->
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>